import React from 'react';
import { Modal, Typography } from 'antd';

const { Text } = Typography;

const InstructionsModal = ({ visible, onCancel }) => {
  const accentColor = '#D56A24';
  const borderColor = '#ff9f01';
  const bgColor = '#faf8ee';
  return (
    <>
      <style>
        {`
          .instructions-modal-theme .ant-modal-content {
            border-radius: 20px !important;
            background: ${bgColor};
            border: 1px solid ${borderColor};
          }
          .instructions-modal-theme .ant-modal-title {
            color: ${accentColor} !important;
            font-weight: 700;
          }
        `}
      </style>
      <Modal
        className="instructions-modal-theme"
        title="How to Get Your Free WiFi Voucher"
        open={visible}
        onCancel={onCancel}
        footer={null}
        centered
      >
      <div>
        <Text strong>💡 How to Get Your Free WiFi Voucher?</Text><br />
        <Text>
          Click the “GET FREE WIFI VOUCHER” button on the portal.
        </Text><br />
        <Text>
          Choose the free plan that best fits your needs.
        </Text><br />
        <Text>
          Click “Get Free Voucher” and wait for a few seconds while your voucher is generated.
        </Text><br />
        <Text>
          Copy your voucher code — you can either manually copy it or tap the “Copy Code” button.
        </Text><br />
        <Text>
          Click “Go to Voucher Login” to return to the login page.
        </Text><br />
        <Text>
          Paste the voucher code into the input field and click “Confirm.”
        </Text><br />
        <Text>✅ Enjoy your free internet access!</Text>
      </div>
      </Modal>
    </>
  );
};

export default InstructionsModal;


